import { create } from "zustand";
import { BillerMaster } from "features/bbps/biller/billerTypes";
import {
  BillerPlan,
  BillFetchResult,
  BillPaymentResult,
} from "features/bbps/biller/billerFlowTypes";

export type PgMeta = {
  attemptId: string;
  razorpayPaymentId: string;
  razorpayOrderId: string;
  status?: string;
  method?: string; // upi/netbanking/card/wallet/paylater
  bank?: string;
  vpa?: string;
  wallet?: string;
  bankTransactionId?: string; // acquirer_data.bank_transaction_id
  fee?: number;
  tax?: number;
};

export type FlowStep =
  | "ENTER_DETAILS"
  | "PLANS_LOADING"
  | "SELECT_PLAN"
  | "BILL_FETCHING"
  | "BILL_FETCHED"
  | "VALIDATING"
  | "VALIDATED"
  | "PAYMENT_GATEWAY"
  | "PAYMENT_PROCESSING"
  | "PAYMENT_DONE";

interface BillFetchContext {
  customerParams: Record<string, string>;
  customerDetails: Record<string, string>;
  customerMobile: string | null;
  referralNumber?: string;
}

interface PaymentFlowState {
  step: FlowStep;
  selectedBiller?: BillerMaster;
  selectedPlan?: BillerPlan;
  refId?: string;
  billAmount?: string;
  billSummary?: BillFetchResult | null;
  billContext?: BillFetchContext;

  paymentResult?: BillPaymentResult | null;

  setStep: (s: FlowStep) => void;
  setBiller: (biller?: BillerMaster) => void;
  setPlan: (plan?: BillerPlan) => void;
  setBillFetchContext: (ctx: BillFetchContext) => void;
  setBillFetchResult: (res: BillFetchResult) => void;
  setBillValidationResult: (refId: string, amount: string) => void;

  setPaymentResult: (res: BillPaymentResult | null) => void;

  receiptOpen: boolean;
  pgMeta?: PgMeta;

  // NEW
  pgError?: string;
  returnPath?: string;

  setReceiptOpen: (v: boolean) => void;
  setPgMeta: (m?: PgMeta) => void;

  // NEW
  setPgError: (e?: string) => void;
  setReturnPath: (p?: string) => void;

  reset: () => void;
}

export const usePaymentFlowStore = create<PaymentFlowState>((set) => ({
  step: "ENTER_DETAILS",
  billSummary: null,
  paymentResult: null,

  setStep: (step) => set({ step }),
  setBiller: (selectedBiller) => set({ selectedBiller }),
  setPlan: (selectedPlan) => set({ selectedPlan }),

  setBillFetchContext: (ctx: BillFetchContext) =>
    set({
      billContext: ctx,
    }),
  setBillFetchResult: (res) =>
    set((state) => ({
      refId: res.refId,
      billAmount: res.billerResponse.amount,
      billSummary: res,
      billContext: state.billContext, // context ko preserve rakhe
      step: "BILL_FETCHED",
    })),
  setBillValidationResult: (refId, amount) =>
    set((state) => ({
      refId,
      billAmount: amount,
      billContext: state.billContext,
      step: "VALIDATED",
    })),

  setPaymentResult: (res) =>
    set({
      paymentResult: res,
      step: "PAYMENT_DONE",
    }),
  receiptOpen: false,
  pgMeta: undefined,

  pgError: undefined,
  returnPath: undefined,

  setReceiptOpen: (receiptOpen) => set({ receiptOpen }),
  setPgMeta: (pgMeta) => set({ pgMeta }),

  setPgError: (pgError) => set({ pgError }),
  setReturnPath: (returnPath) =>
    set((state) => (state.returnPath === returnPath ? state : { returnPath })),

  reset: () =>
    set({
      step: "ENTER_DETAILS",
      selectedBiller: undefined,
      selectedPlan: undefined,
      refId: undefined,
      billAmount: undefined,
      billSummary: null,
      billContext: undefined,
      paymentResult: null,

      receiptOpen: false,
      pgMeta: undefined,

      pgError: undefined,
      returnPath: undefined,
    }),
}));

// export type FlowStep =
//   | "ENTER_DETAILS"
//   | "PLANS_LOADING"
//   | "SELECT_PLAN"
//   | "BILL_FETCHING"
//   | "BILL_FETCHED"
//   | "VALIDATING"
//   | "VALIDATED"
//   | "PAYMENT_GATEWAY"
//   | "PAYMENT_PROCESSING"
//   | "PAYMENT_DONE";

// interface BillFetchContext {
//   customerParams: Record<string, string>;
//   customerDetails: Record<string, string>;
//   customerMobile: string;
//   referralNumber?: string;
// }

// interface PaymentFlowState {
//   step: FlowStep;
//   selectedBiller?: BillerMaster;
//   selectedPlan?: BillerPlan;
//   refId?: string;
//   billAmount?: string;
//   billSummary?: BillFetchResult | null;
//   billContext?: BillFetchContext;

//   paymentResult?: BillPaymentResult | null;

//   setStep: (s: FlowStep) => void;
//   setBiller: (biller?: BillerMaster) => void;
//   setPlan: (plan?: BillerPlan) => void;
//   setBillFetchContext: (ctx: BillFetchContext) => void;
//   setBillFetchResult: (res: BillFetchResult) => void;
//   setBillValidationResult: (refId: string, amount: string) => void;

//   setPaymentResult: (res: BillPaymentResult) => void;
//   reset: () => void;
// }

// export const usePaymentFlowStore = create<PaymentFlowState>((set) => ({
//   step: "ENTER_DETAILS",
//   billSummary: null,
//   paymentResult: null,

//   setStep: (step) => set({ step }),
//   setBiller: (selectedBiller) => set({ selectedBiller }),
//   setPlan: (selectedPlan) => set({ selectedPlan }),

//   setBillFetchContext: (ctx: BillFetchContext) =>
//     set({
//       billContext: ctx,
//     }),
//   setBillFetchResult: (res) =>
//     set((state) => ({
//       refId: res.refId,
//       billAmount: res.billerResponse.amount,
//       billSummary: res,
//       billContext: state.billContext, // context ko preserve rakhe
//       step: "BILL_FETCHED",
//     })),
//   setBillValidationResult: (refId, amount) =>
//     set((state) => ({
//       refId,
//       billAmount: amount,
//       billContext: state.billContext,
//       step: "VALIDATED",
//     })),

//   setPaymentResult: (res) =>
//     set({
//       paymentResult: res,
//       step: "PAYMENT_DONE",
//     }),
//   reset: () =>
//     set({
//       step: "ENTER_DETAILS",
//       selectedBiller: undefined,
//       selectedPlan: undefined,
//       refId: undefined,
//       billAmount: undefined,
//       billSummary: null,
//       billContext: undefined,
//       paymentResult: null,
//     }),
// }));
